import global from './global';

document.addEventListener('DOMContentLoaded', () => {
  global.init();
});
